import React from "react";
import ReactDOM from "react-dom";

import preloaded from "../../src/preloaded.js";
import AvailabilityQuickLook from "../../src/availability/2022/AvailabilityQuickLook.jsx";

const target = document.getElementById("availabilityQuickLook");
if (target && preloaded.availability_url) {
  ReactDOM.render(
    <AvailabilityQuickLook
      childMembers={preloaded.child_members}
      currentMember={preloaded.current_member}
      targetDate={preloaded.availability_date}
      sourceUrl={preloaded.availability_url}
    />
  , target);
}